import { useEffect } from 'react';

declare global {
  interface Window {
    // @ts-ignore
    Intercom?: any;
    // @ts-ignore
    intercomSettings?: any;
  }
}

export const useIntercom = (shouldDisplay: boolean = true) => {
  useEffect(() => {
    // Check if we're in a browser environment and DOM is ready
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Wait for DOM to be ready
    const initializeIntercom = () => {
      // Check if Intercom is available and properly configured
      if (typeof window.Intercom !== 'undefined') {
        if (!shouldDisplay) {
          // Shutdown Intercom
          try {
            window.Intercom('shutdown');
          } catch (error) {
            // Silently handle Intercom shutdown errors
          }

          // Remove the Intercom frame
          const frame = document.querySelector('#intercom-frame');
          if (frame) {
            frame.remove();
          }

          // Remove the Intercom container
          const container = document.querySelector('#intercom-container');
          if (container) {
            container.remove();
          }
        } else {
          // Restart Intercom if it was previously shutdown
          // Only boot if intercomSettings is available and not null
          if (window.intercomSettings && typeof window.intercomSettings === 'object') {
            try {
              window.Intercom('boot', window.intercomSettings);
            } catch (error) {
              // Silently handle Intercom boot errors
            }
          }
        }
      }
    };

    // If DOM is already ready, initialize immediately
    if (document.readyState === 'complete') {
      initializeIntercom();
    } else {
      // Otherwise wait for load event
      const handleLoad = () => {
        initializeIntercom();
      };
      window.addEventListener('load', handleLoad);

      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }

    return () => {
      // Cleanup when component unmounts
      if (typeof window.Intercom !== 'undefined' && !shouldDisplay) {
        try {
          window.Intercom('shutdown');
        } catch (error) {
          // Silently handle Intercom shutdown errors
        }
      }
    };
  }, [shouldDisplay]);
};
